import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Shuffle"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.9425 14.5575L19.6275 17.25H14.6625L11.385 12L14.6625 6.75H19.6275L16.9425 9.4425L18 10.5L22.5 6L18 1.5L16.9425 2.5575L19.6275 5.25H14.6625C14.1469 5.25155 13.6683 5.51778 13.395 5.955L10.5 10.5825L7.605 5.955C7.33174 5.51778 6.85308 5.25155 6.3375 5.25H1.5V6.75H6.3375L9.615 12L6.3375 17.25H1.5V18.75H6.3375C6.85308 18.7485 7.33174 18.4822 7.605 18.045L10.5 13.4175L13.395 18.045C13.6683 18.4822 14.1469 18.7485 14.6625 18.75H19.6275L16.9425 21.4425L18 22.5L22.5 18L18 13.5L16.9425 14.5575Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Shuffle.vue"]]);
